/**
 * @description Header Link ID (enum)
 */
export enum HeaderLinkIdEnum {
  /** 網路專屬商品 */
  EcxclusiveProduct = 'ecxclusiveProduct',
  /** 網路保單查詢 */
  PolicyInquiry = 'policyInquiry'
}

/**
 * @description Footer Link ID (enum)
 */
export enum FooterLinkIdEnum {
  /** 資訊揭露 */
  Disclosure = 'disclosure',
   /** 法規遵循事項及公告 */
  Announcement = 'announcement',
  /** 主管機關相關連結 */
  RelatedLink = 'relatedLink',
  /** 資料保密措施 隱私保護頁面 */
  SecurityProtect = 'securityProtect',
  /** 客服電話 */
  CustomerServHotline = 'customerServHotline',
  /** 地址 */
  Address = 'address',
  /** 臺銀人壽版權所有 */
  Copyright = 'copyright',
  /** 建議解析度 */
  Resolution = 'resolution',
  /** 建議瀏覽環境 */
  Browser = 'browser'
}
